// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';
import wysiwyg from 'vue-wysiwyg';
import '../node_modules/vue-wysiwyg/dist/vueWysiwyg.css';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';
import Amplify from 'aws-amplify';

// font awesome libs
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck, faFileDownload, faSpinner, faSort, faPoll, faInfo, faEdit, faTrash, faCaretDown, faCaretUp, faClone, faCopy
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import router from './router';
import App from './App.vue';

Vue.use(VueResource);
Vue.use(require('vue-moment'));

Vue.use(wysiwyg, {});

Vue.use(BootstrapVue);

// more fontawesome stuff
library.add(faCheck, faFileDownload, faSpinner, faSort, faPoll, faInfo, faEdit, faTrash, faCaretDown, faCaretUp, faClone, faCopy);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Amplify
Amplify.configure({
  Auth: {
    UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    Cognito: {
      userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    }
  },
  aws_user_pools_id: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.VUE_APP_COGNITO_CLIENT_ID,
  oauth: {
    domain: process.env.VUE_APP_COGNITO_DOMAIN,
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: process.env.VUE_APP_BRAIN_URL,
    redirectSignOut: process.env.VUE_APP_BRAIN_URL,
    responseType: 'code'
  }
});
applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    currentSession: undefined,
    signedIn: false,
    API_ENDPOINT: process.env.API_ENDPOINT
  }
});



// WEBPACK FOOTER //
// ./src/main.js